import { c as _c } from "react/compiler-runtime";
import { useDraw } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import type { Outcome } from '@svs/nova-poolbetting/schema/coupon';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { MultiForecast as MultiForecastData, MultiForecastOutcome } from '@svs/nova-poolbetting/schema/forecast';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { ReactNode } from 'react';
import { MultiForecast } from './MultiForecast';
type MultiForecastContainerProps = {
  multiForecast: MultiForecastData[];
  selectedOutcome?: MultiForecastOutcome;
  currentCorrectResult: undefined | Outcome;
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
};

/**
 * MultiForecastContainer component.
 *
 * @param root0 props
 * @param root0.multiForecast multi forecast data for draw
 * @param root0.selectedOutcome user selected outcome for multi forecast
 * @param root0.currentCorrectResult current correct result for last event
 * @param root0.drawNumber draw number for the current draw
 * @param root0.product product for the current draw
 * @returns The MultiForecast presentational component.
 */
export function MultiForecastContainer(t0) {
  const $ = _c(25);
  const {
    multiForecast,
    selectedOutcome,
    currentCorrectResult,
    drawNumber,
    product
  } = t0;
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      drawNumber,
      product
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const drawResponse = useDraw(t1);
  if (drawResponse.isError) {
    let t2;
    if ($[3] !== currentCorrectResult || $[4] !== multiForecast || $[5] !== selectedOutcome) {
      t2 = <MultiForecast multiForecast={multiForecast} selectedOutcome={selectedOutcome} currentCorrectResult={currentCorrectResult} />;
      $[3] = currentCorrectResult;
      $[4] = multiForecast;
      $[5] = selectedOutcome;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  const {
    draw,
    bettingEvent
  } = drawResponse.data;
  const drawParticipants = drawResponse.data.participants;
  let t2;
  if ($[7] !== draw.events || $[8] !== multiForecast) {
    let t3;
    if ($[10] !== multiForecast) {
      t3 = event => event.eventNumber === multiForecast[0]?.eventNumber;
      $[10] = multiForecast;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = draw.events.find(t3);
    $[7] = draw.events;
    $[8] = multiForecast;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const event_0 = t2;
  if (!event_0 || event_0.status !== "COMPLETE") {
    let t3;
    if ($[12] !== currentCorrectResult || $[13] !== multiForecast || $[14] !== selectedOutcome) {
      t3 = <MultiForecast multiForecast={multiForecast} selectedOutcome={selectedOutcome} currentCorrectResult={currentCorrectResult} />;
      $[12] = currentCorrectResult;
      $[13] = multiForecast;
      $[14] = selectedOutcome;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    return t3;
  }
  const {
    bettingEventId
  } = event_0;
  let t3;
  if ($[16] !== bettingEvent || $[17] !== bettingEventId || $[18] !== drawParticipants) {
    t3 = bettingEvent[bettingEventId]?.participants.map(participantId => drawParticipants[participantId]);
    $[16] = bettingEvent;
    $[17] = bettingEventId;
    $[18] = drawParticipants;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const participants = t3;
  let t4;
  if ($[20] !== currentCorrectResult || $[21] !== multiForecast || $[22] !== participants || $[23] !== selectedOutcome) {
    t4 = <MultiForecast multiForecast={multiForecast} selectedOutcome={selectedOutcome} currentCorrectResult={currentCorrectResult} participants={participants} />;
    $[20] = currentCorrectResult;
    $[21] = multiForecast;
    $[22] = participants;
    $[23] = selectedOutcome;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
}